import { MessageType } from '../../enums/message-type';

export class WebViewMessage {
  public constructor(public messageType: MessageType) {}
}
